module.exports = __webpack_public_path__ + "img/times-regular.08f67f6e.svg";